'use strict';

var CmdDevice = require('./util/CmdDevice');
var log = require('../../../log/Log').channel('WyreStormExSw');

function WyreStormExSw(ipAddress, username, password, onConnectStatus, onControlStatus, config) {
    this.txSrc = null;  // default source selected on transmitter
    this.busy = false;
    this.firmwareVersion = 'unknown';
    this.videoMatrixRoutes = {};
    this.pollCycle = 0;

    CmdDevice.call(this, ipAddress, username, password, onConnectStatus,
        onControlStatus, config);
}

WyreStormExSw.prototype = Object.create(CmdDevice.prototype);

WyreStormExSw.prototype.constructor = WyreStormExSw;

WyreStormExSw.prototype.name = 'WyreStormExSw';
WyreStormExSw.prototype.key = '-M23l4mLOkUwiDWkY2Bm';
WyreStormExSw.prototype.isAsync = false;
WyreStormExSw.prototype.rejectAsync = false;
WyreStormExSw.prototype.syncTimeoutMs = 2000;
WyreStormExSw.prototype.pingMs = 4000;
WyreStormExSw.prototype.pollIntervalMs = 2000;
WyreStormExSw.prototype.sendTerminator = '\r\n';
WyreStormExSw.prototype.receiveTerminators = ['\r', '\n'];

WyreStormExSw.prototype.ports = [{
    port: 4999,
    verifySend: '\r\nGET AUTOSW_FN',
    verifyConnection: /AUTOSW_FN/i,
    verifyTimeoutMs: 3000,
    loginSkip: null,
    loginVerifyTimeoutMs: 0,
    passwordPrompt: null,
    passwordPromptTimeoutMs: 0,
    passwordDefault: null,
    passwordSend: null,
    loginVerify: null,
    loginReject: null,
},{
    port: 23,
    verifySend: '\r\n',
    verifyConnection: /Welcome To This Telnet Control System/i,
    verifyTimeoutMs: 3000,
    loginSkip: null,
    loginVerifyTimeoutMs: 0,
    passwordPrompt: null,
    passwordPromptTimeoutMs: 0,
    passwordDefault: null,
    passwordSend: null,
    loginVerify: null,
    loginReject: null,
}];

WyreStormExSw.prototype.simulationParams = {
    caps: {
        hasVideoInputs: true,
        hasVideoOutputs: true,
        hasVideoSwitcher: true,
        hasFirmwareVersion: true,
    },
    firmwareVersion: '1.4',
};

WyreStormExSw.prototype.commands = {};

WyreStormExSw.prototype.commands.$getRoute = {};
WyreStormExSw.prototype.commands.$getRoute.match = /MP\s(.+)\s(RX|TX)/i;
WyreStormExSw.prototype.commands.$getRoute.process = function(match) {
    this.processSelectedInput(match);
};

WyreStormExSw.prototype.commands.$getRouteInit = {};
WyreStormExSw.prototype.commands.$getRouteInit.activeStates = [ 'initializing' ];
WyreStormExSw.prototype.commands.$getRouteInit.activeInitializeStates = [ 'gettingRoutes' ];
WyreStormExSw.prototype.commands.$getRouteInit.get = function() {
    var outIds = Object.keys(this.config.videoOutputs).sort();
    var outCode =
        this.config.videoOutputs[outIds[this.initializeRepeatIndex]].code;

    this.sendCommand('$getRouteInit', 'GET MP ' + outCode);
};
WyreStormExSw.prototype.commands.$getRouteInit.match = /MP\s(.+)\s(RX|TX)/i;
WyreStormExSw.prototype.commands.$getRouteInit.process = function(match) {
    this.processSelectedInput(match);
    this.doNextInitializeStep();
};


WyreStormExSw.prototype.commands.$version = {};
WyreStormExSw.prototype.commands.$version.activeStates = [ 'initializing' ];
WyreStormExSw.prototype.commands.$version.activeInitializeStates = [ 'gettingVersion' ];
WyreStormExSw.prototype.commands.$version.get = function() {
    if (this.hasSync('$version')) return;
    this.sendCommand('$version', 'GET VER');
};
WyreStormExSw.prototype.commands.$version.match = /(?:VER\s+)?(.+)|APP ERROR/i;
WyreStormExSw.prototype.commands.$version.process = function(match) {
    if (typeof match[1] !== 'undefined') {
        this.firmwareVersion = match[1];
    }
    this.doNextInitializeStep();
};

WyreStormExSw.prototype.commands.busy = {};
WyreStormExSw.prototype.commands.busy.get = function() {
    this.broadcastStatus('busy', this.busy);
};

WyreStormExSw.prototype.commands.firmwareVersion = {};
WyreStormExSw.prototype.commands.firmwareVersion.get = function() {
    this.broadcastStatus('firmwareVersion', this.firmwareVersion);
};

WyreStormExSw.prototype.commands.ping = {};
WyreStormExSw.prototype.commands.ping.isAsync = true;
WyreStormExSw.prototype.commands.ping.activeStates = [ 'controlling', 'controlFailed' ];
WyreStormExSw.prototype.commands.ping.get = function() {
    this.sendCommand('ping', 'GET AUTOSW_FN');
};
WyreStormExSw.prototype.commands.ping.match = /AUTOSW_FN|APP ERROR/i;

WyreStormExSw.prototype.commands.videoMatrixRoute = {};
WyreStormExSw.prototype.commands.videoMatrixRoute.isAsync = true;
WyreStormExSw.prototype.commands.videoMatrixRoute.get = function() {
    this.broadcastStatus('videoMatrixRoute', this.videoMatrixRoutes);
};
WyreStormExSw.prototype.commands.videoMatrixRoute.set = function(value) {
    if (!this.videoMatrixRoutes.hasOwnProperty(value.videoOutputId)) {
        log.error(this + ' invalid videoOutputId = ' + value.videoOutputId);
        return;
    }

    if (!this.config.videoInputs.hasOwnProperty(value.videoInputId)) {
        log.error(this + ' invalid videoInputId = ' + value.videoInputId);
        return;
    }

    this.videoMatrixRoutes[value.videoOutputId] = value.videoInputId;
    this.broadcastStatus('videoMatrixRoute', this.videoMatrixRoutes);

    this.sendCommand('videoMatrixRoute', 'SET SW ' +
        this.config.videoInputs[value.videoInputId].code + ' ' +
        this.config.videoOutputs[value.videoOutputId].code);
    this.setBusy(true, 0);
    this.setBusy(false, 1000);
};
WyreStormExSw.prototype.commands.videoMatrixRoute.match = /^SW\s(.+)\s(RX|TX)|APP ERROR/i;
WyreStormExSw.prototype.commands.videoMatrixRoute.process = function(match) {
    if (typeof match[1] !== 'undefined')
        this.processSelectedInput(match);
};

WyreStormExSw.prototype.initializeSteps = [{
    state: 'gettingVersion',
    action: '$version',
}, {
    state: 'gettingRoutes',
    action: '$getRouteInit',
    getRepeatCount: function() {
        return this.config.hasOwnProperty('videoOutputs') ?
            Object.keys(this.config.videoOutputs).length : 0;
    },
}, {
    state: 'finishingInitialization',
    action: function() {
        this.finishInitialization();
        return true;
    },
}];

WyreStormExSw.prototype.onComputeCaps = function() {
    var caps = this.getCapsTemplate();
    caps.hasVideoSwitcher = true;
    this.computeCapsFromConfig(caps);
    caps.hasBusy = true;
    caps.hasFirmwareVersion = true;

    return caps;
};

WyreStormExSw.prototype.onInitialize = function() {
    this.busy = false;
    this.videoMatrixRoutes = {};
    this.startInitializer();
};

WyreStormExSw.prototype.onPoll = function() {
    if (!this.config.hasOwnProperty('videoOutputs')) return;

    var outIds = Object.keys(this.config.videoOutputs).sort();
    if (this.pollCycle < 0 || this.pollCycle >= outIds.length) {
        log.error(this + ': pollCycle ' + this.pollCycle + ' out of range');
        this.pollCycle = 0;
    }

    var outCode = this.config.videoOutputs[outIds[this.pollCycle]].code;
    this.sendCommand('$getRoute', 'GET MP ' + outCode);
    this.pollCycle++;

    if (this.pollCycle >= outIds.length) this.pollCycle = 0;
};

WyreStormExSw.prototype.processSelectedInput = function(match) { 
    // match[1] = source, match[2] = destination
    // track transmitter source for when the ack only
    // shows the RXHDBT input to the receiver

    if (match[1] !== 'RXHDMI1' && match[1] !== 'RXHDMI2' && match[1] !== 'RXHDBT') { // not a receiver source
        this.txSrc = match[1];
    }

    // if we received RXHDBT, then the receiver is selecting
    // the transmitter source: this.txSrc

    if (match[1] === 'RXHDBT') {
        if (this.txSrc !== null) {
            this.updateVideoMatrixRoute(this.txSrc, match[2]);
        } else { // for receiver only installs where there is no tx
            this.updateVideoMatrixRoute(match[1], match[2]);
        }
    } else { 
        this.updateVideoMatrixRoute(match[1], match[2]);
    }
};

WyreStormExSw.prototype.removePollCommands = function() { 
    this.cmdSocket.removeSync('$getRoute');
};

WyreStormExSw.prototype.updateVideoMatrixRoute = function(inputCode, outputCode) {
    var inputId = null;
    var outputId = null;

    for (var inId in this.config.videoInputs) {
        if (!this.config.videoInputs.hasOwnProperty(inId)) continue;
        if (this.config.videoInputs[inId].code === inputCode) {
            inputId = inId;
            break;
        }
    }

    if (inputId === null) {
        log.warning(this + ': unmatched video input code: ' + inputCode);
    }

    for (var outId in this.config.videoOutputs) {
        if (!this.config.videoOutputs.hasOwnProperty(outId)) continue;
        if (this.config.videoOutputs[outId].code === outputCode) {
            outputId = outId;
            break;
        }
    }

    if (outputId === null) {
        log.warning(this + ': unmatched video output code: ' + outputCode);
    } else {
        if (this.videoMatrixRoutes[outputId] !== inputId) {
            this.videoMatrixRoutes[outputId] = inputId;
            if (this.fsm.current === 'controlling') {
                this.broadcastStatus('videoMatrixRoute', this.videoMatrixRoutes);
            }
        }
    }
};

module.exports = WyreStormExSw;
